import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {AdminService} from '../../shared/services/admin.service';
import {AlertService} from '../../shared/services/alert.service';
import {StorageService} from '../../shared/services/storage.service';

// Mirrors the backend's Referral::MANUAL_STATUSES (ReferralRelationService) — the only
// statuses an admin may set. CONVERTED is "Admission Done": it pays the referrer's reward once.
const REFERRAL_STATUS_OPTIONS = [
    {value: 'REGISTERED', label: 'Registered'},
    {value: 'PENDING', label: 'Pending'},
    {value: 'CONVERTED', label: 'Admission Done (pays referrer)'},
    {value: 'CLOSED', label: 'Closed'},
];


@Component({
    selector: 'app-referral-leads',
    templateUrl: './referral-leads.component.html',
    styleUrls: ['./referral-leads.component.scss']
})
export class ReferralLeadsComponent implements OnInit {
    showSearch = false;
    submitting: any = false;
    submitted: any = false;
    searchForm: FormGroup;
    followUpForm: FormGroup;
    user: any;
    pagination = {
        page: 1,
        total: 0,
        perpage: 15,
        pages: 0
    };

    statusOptions = REFERRAL_STATUS_OPTIONS;
    selectedReferrer: any;


    dataToFilter = [];
    filteredData: any;
    matchedItem: any;


    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private adminService: AdminService,
                private alertService: AlertService) {

        this.user = StorageService.getItem('self');
    }

    ngOnInit(): void {
        this.refresh();

    }

    refresh() {
        this.searchForm = this.fb.group({
            email: [''],
            contact: ['']
        });
        this.followUpForm = this.fb.group({
            'status': ['', Validators.required],
            'reason': ['']
        });

        this.searchForm.valueChanges.subscribe(() => {
            this.search();
        });

        this.getReferrers();
    }


    getReferrers(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.dataToFilter = [];
        this.adminService.getReferrers(params).subscribe(res => {
                if (res && res['data'] && res['data'].length > 0) {
                    this.dataToFilter = res.data;
                    this.pagination = {
                        page: res.current_page,
                        total: res.total,
                        perpage: res.per_page,
                        pages: res.last_page,
                    };
                }
                this.submitting = false;
            },
            (error) => {
                console.error('Error fetching referrers:', error);
                this.submitting = false;
            }
        );
    }


    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.getReferrers({page: 1, total: null, perpage: 45, pages: null});
        }
    }


    onPageChange(page) {
        this.pagination.page = page;

        const params = {
            'name': this.searchForm.value?.name || '',
            'email': this.searchForm.value?.email || '',
            'mobile': this.searchForm.value?.contact || ''
        };
        this.getReferrers(params);

    }


    search() {
        const emailControl = this.searchForm.get('email');
        const contactControl = this.searchForm.get('contact');

        if (!emailControl || !contactControl) {
            return;
        }

        const email = emailControl.value ? emailControl.value.toLowerCase() : '';
        const contact = contactControl.value ? contactControl.value.toString().toLowerCase() : '';

        this.filteredData = this.dataToFilter.filter(item => {
            const itemEmail = (item.email || '').toLowerCase();
            const itemContact = (item.mobile || '').toString().toLowerCase();

            const emailMatch = email === '' || itemEmail.includes(email);
            const contactMatch = contact === '' || itemContact.includes(contact);

            return emailMatch && contactMatch;
        });

        if (this.filteredData.length === 1) {
            this.showMatchedData(this.filteredData[0]);
        }
    }


    showMatchedData(matchedItem) {
        this.matchedItem = matchedItem;
    }


    changeFollowUp(content, admin) {
        this.selectedReferrer = admin;
        this.submitted = false;
        this.followUpForm.reset({
            status: admin?.inbound_referral_status || '',
            reason: ''
        });
        this.modalService.open(content, {size: 'lg'});
    }

    followUp() {
        this.submitted = true;
        if (!this.followUpForm.valid || !this.selectedReferrer?.inbound_referral_id) {
            return;
        }
        const params = {
            status: this.followUpForm.value.status,
            reason: this.followUpForm.value.reason || ''
        };
        this.submitting = true;
        this.adminService.updateReferralStatus(this.selectedReferrer.inbound_referral_id, params).subscribe(() => {
            this.submitting = false;
            this.submitted = false;
            this.modalService.dismissAll('');
            this.getReferrers();
        }, error => {
            this.submitting = false;
            if (error && error['error'] && error['error']['errorDetails']) {
                this.alertService.showErrors(error['error']['errorDetails']);
            }
        });
    }


}
